import { render } from "./BodyType.vue?vue&type=template&id=e5e2514a"
import script from "./BodyType.vue?vue&type=script&lang=js"
export * from "./BodyType.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\sonic\\renault\\new_resources\\renault_configurator\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__